import React, { useState } from "react";
import CheckBox from "../../Buttons/CheckBox";
import Pagination from "../../Common/Pagination";

export interface MultiSelectData {
  id: string;
  display: string;
  selected: boolean;
}

type Props = {
  data: MultiSelectData[];
  pageSize?: number;
  onClickCheckBox: (id: string) => void;
  columnSize?: number;
  style?: React.CSSProperties;
  usePagination?: boolean;
  checkBoxVariant?: "default" | "alternate";
  checkBoxStyle?: React.CSSProperties;
  containerStyle?: React.CSSProperties;
};

const ToolsContentCheckBoxGroup = ({
  data,
  pageSize = 27,
  onClickCheckBox = () => {},
  columnSize = 3,
  style,
  usePagination = true,
  checkBoxVariant = "default",
  checkBoxStyle,
  containerStyle,
}: Props) => {
  const [pageIndex, setPageIndex] = useState(0);

  const pageCount = Math.round(data.length / pageSize);
  const canNext = pageIndex + 1 < pageCount - 1;
  const canPrevious = pageIndex - 1 > -1;

  const goToPage = (index: number) => {
    setPageIndex(index);
  };

  const goToNextPage = () => {
    goToPage(pageIndex + 1);
  };

  const goToPrevPage = () => {
    goToPage(pageIndex - 1);
  };

  let finalData = [];
  if (usePagination) finalData = data.slice(pageIndex, (pageSize - 1) * (pageIndex + 1));
  else finalData = data;

  const columnLength = 100.0 / columnSize;

  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        flexDirection: "row",
        justifyContent: "flex-start",
        ...style,
      }}
    >
      {finalData.map((cell: MultiSelectData) => {
        return (
          <div style={containerStyle}>
            <CheckBox
            id={cell.id}
            name={cell.id}
            label={cell.display}
            checked={cell.selected}
            onChange={onClickCheckBox}
            colorVariant={checkBoxVariant}
            style={{
              paddingTop: 4,
              marginBottom: 36,
              fontSize: 14,
              width: `calc(${columnLength}% - 35px)`,
              flexBasis: `calc(${columnLength}% - 35px)`,
              ...checkBoxStyle,
            }}
          />
          </div>
        );
      })}

      {usePagination && (
        <div
          style={{
            flex: "1 1 100%",
            alignSelf: "flex-end",
            marginTop: 10,
          }}
        >
          <Pagination
            canNextPage={canNext}
            canPreviousPage={canPrevious}
            gotoPage={goToPage}
            nextPage={goToNextPage}
            pageCount={pageCount}
            pageIndex={pageIndex}
            previousPage={goToPrevPage}
          />
        </div>
      )}
    </div>
  );
};

export default ToolsContentCheckBoxGroup;
